export const THEMES = {
  LIGHT: 'LIGHT',
  FOREST: 'FOREST',
  NEON: 'NEON',
  TERMINAL: 'TERMINAL',
};

export const THEME_PRIME_COLORS = {
  LIGHT: ['#79a574', '#2c3430', '#e4e6e9', '#5a7a68'],
  FOREST: ['#2c3430', '#38403d', '#48534f', '#5a7a68', '#79a574'],
  NEON: ['#2c2c34', '#383a40', '#494657', '#605d86', '#a775aa'],
  TERMINAL: ['#000000', '#141414', '#1d2236', '#485797', '#6a7ccc'],
};

export const LOCAL_STORAGE_KEYS = {
  AccessToken: 'accessToken',
  CustomerPresent: 'CustomerPresent',
  SelectedCustomer: 'selectedCustomer_v4',
  PreviousSearches: 'PreviousSearches',
  PreviousViews: 'PreviousViews',
  IncompleteTasks: 'IncompleteTasks',
  AllSFAUsers: 'AllSFAUsers',
  AllCrmUsers: 'AllCrmUsers',
  NotificationsArePaused: 'NotificationsArePaused',
  CustomerShipTo: 'CustomerShipTo',
  RecentlySelectedCustomers: 'recentlySelectedCustomers',
};

export const SETTING_KEYS = {
  Settings: 'settings',

  //Grids
  UnsubmittedOrderGridCols: 'unsubmittedOrderGridCols',
  OpenOrderGridCols: 'openOrderGridCols',
  PerfectOrderGridCols: 'perfectOrderGridCols',
  OrderItemGridCols: 'orderItemGridCols',
  OpenDocumentDetailGridCols: 'openDocumentDetailGridCols',
  OrderDetailsGrid: 'orderDetailsGrid',
  ItemSearchGridCols: 'itemSearchGridCols',
  OpenOrderGridPageSize: 'openOrderGridPageSize',
  PerfectOrderGridPageSize: 'perfectOrderGridPageSize',
  UnsubmittedOrderGridPageSize: 'unsubmittedOrderGridPageSize',
  ActivityGridPageSize: 'activityGridPageSize',
  ItemSearchGridPageSize: 'itemSearchGridPageSize',
  CustomerShowPageSize: 'customerShowPageSize',
  CustomerContactsPageSize: 'customerContactsPageSize',
  CustomerShowAttendeesPageSize: 'customerShowAttendeesPageSize',
  CustomerCartSummaryPageSize: 'customerCartSummaryPageSize',
};

export const SESSION_STORAGE_KEYS = {
  SearchRequest: 'searchRequest',
  OpenOrderSearchString: 'openOrderSearchString',
};

export const LEAD_TIMES = {
  DEFAULT_LEAD_TIME_DAYS: 21,
  ADDITIONAL_LEAD_TIME_DAYS: 0,
};

/*
These come from this c# class, make sure they are in sync
public static class SfaMessageType
{
    public const string CrmUpdate = "CrmUpdate";
    public const string SnackAlert = "SnackAlert";
}
*/
export const SFA_MESSAGE_TYPE = {
  CrmUpdate: 'CrmUpdate',
  SnackAlert: 'SnackAlert',
};
